module.exports = __webpack_public_path__ + "img/Europa.c8f99a05.svg";